// This file contains utility functions for the Redux store
// to avoid circular dependencies

let storeInstance = null;

// Set the store instance
export const setStore = (store) => {
  storeInstance = store;
};

// Create a function to dispatch actions
export const dispatchAction = (action) => {
  if (!storeInstance) {
    console.error('Store instance not set. Call setStore first.');
    return;
  }
  return storeInstance.dispatch(action);
};